import styles from "./tab-container.module.css";

import classnames from "classnames";
import { useEffect, useState } from "react";

export interface TabData {
  component: any;
  title: string;
}

export interface ITabContainerProps {
  tabList: TabData[];
  defaultTab: number;
  onTabChange?(index: number): void;
}

export function TabContainer(props: ITabContainerProps) {
  const [tabIndex, setTabIndex] = useState(0);
  const { onTabChange } = props;

  useEffect(() => {
    const { defaultTab } = props;
    setTabIndex(defaultTab);
  }, []);

  const handleClickTab = (index: number) => {
    setTabIndex(index);
    if (onTabChange) onTabChange(index);
  };

  const renderTabButtons = () => {
    const { tabList } = props;

    return tabList.map((tabData, index) => {
      return (
        <>
          <div
            className={classnames(styles["tab-button"], {
              [styles["selected"]]: index === tabIndex,
            })}
            onClick={() => handleClickTab(index)}
          >
            {tabData.title}
            <div
              className={classnames(styles["underline"], {
                [styles["selected"]]: index === tabIndex,
              })}
            ></div>
          </div>
        </>
      );
    });
  };

  const renderContent = () => {
    const { tabList } = props;

    return tabList[tabIndex].component;
  };

  return (
    <>
      <div className={"tab-buttons-container"}>{renderTabButtons()}</div>
      {renderContent()}
    </>
  );
}
